import * as fatchSet from "../api/api";

//핸드폰번호 포멧
function PhoneSetting(str) {
    str = str.replace(/[^0-9]/g, '');
    var tmp = '';
    if (str.length < 4) {
        return str;
    } else if (str.length < 7) {
        tmp += str.substr(0, 3);
        tmp += '-';
        tmp += str.substr(3);
        return tmp;
    } else if (str.length < 11) {
        tmp += str.substr(0, 3);
        tmp += '-';
        tmp += str.substr(3, 3);
        tmp += '-';
        tmp += str.substr(6);
        return tmp;
    } else {
        tmp += str.substr(0, 3);
        tmp += '-';
        tmp += str.substr(3, 4);
        tmp += '-';
        tmp += str.substr(7);
        return tmp;
    }

    return str;
}

function birthSetting(str) {
	str = str.replace(/[^0-9]/g, '');
	var tmp = '';
	if (str.length < 5) {
		return str.slice(0, 10);
	} else if (str.length < 7) {
		tmp += str.substr(0, 4);
		tmp += '.';
		tmp += str.substr(4);

		return tmp.slice(0, 10);
	} else {
		tmp += str.substr(0, 4);
		tmp += '.';
		tmp += str.substr(4, 2);
		tmp += '.';
		tmp += str.substr(6);

		return tmp.slice(0, 10);
	}
}

//유효기간 형식 세팅
function cardDateSetting(str) {
	str = str.replace(/[^0-9]/g, "");
	var tmp = "";
  
	if (str.length < 3) {
	  return str;
	} else if (str.length < 5) {
	  tmp += str.substr(0, 2);
	  tmp += "/";
	  tmp += str.substr(2);
	  return tmp;
	} else if (str.length >= 5 && str.indexOf("/") == -1) {
	  str = str.substr(0, 4);
  
	  tmp += str.substr(0, 2);
	  tmp += "/";
	  tmp += str.substr(2);
	  return tmp;
	}
  
	return str;
}

//유효기간 형식 세팅
function cardBirthSetting(str) {
	str = str.replace(/[^0-9]/g, "");
	var tmp = "";
  
	if (str.length < 3) {
	  	return str;
	} else if (str.length < 5) {
		tmp += str.substr(0, 2);
		tmp += "/";
		tmp += str.substr(2);
		return tmp;
	} else {
		tmp += str.substr(0, 2);
		tmp += '/';
		tmp += str.substr(2, 2);
		tmp += '/';
		tmp += str.substr(4);

		return tmp.slice(0, 10);
	}
  
	return str;
}

function CardNumberSetting(str) {
    str = str.replace(/[^0-9]/g, '');
    var tmp = '';
    if (str.length < 5) {
        return str;
    } else if (str.length < 9) {
        tmp += str.substr(0, 4);
        tmp += '-';
        tmp += str.substr(4);
        return tmp;
    } else if (str.length < 13) {
        tmp += str.substr(0, 4);
        tmp += '-';
        tmp += str.substr(4, 4);
        tmp += '-';
        tmp += str.substr(8);
        return tmp;
    } else if (str.length < 17) {
        tmp += str.substr(0, 4);
        tmp += '-';
        tmp += str.substr(4, 4);
        tmp += '-';
		tmp += str.substr(8, 4);
        tmp += '-';
        tmp += str.substr(12);
        return tmp;
    } else {
        tmp += str.substr(0, 4);
        tmp += '-';
        tmp += str.substr(4, 4);
        tmp += '-';
		tmp += str.substr(8, 4);
        tmp += '-';
        tmp += str.substr(12);
        return tmp;
    }

    return str;
}

function BusinessNumberSetting(str) {
    str = str.replace(/[^0-9]/g, '');
    var tmp = '';
    if (str.length < 4) {
        return str;
    } else if (str.length < 6) {
        tmp += str.substr(0, 3);
        tmp += '-';
        tmp += str.substr(3);
        return tmp;
    } else if (str.length < 10) {
        tmp += str.substr(0, 3);
        tmp += '-';
        tmp += str.substr(3, 2);
        tmp += '-';
        tmp += str.substr(5);
        return tmp;
    } else {
        tmp += str.substr(0, 3);
        tmp += '-';
        tmp += str.substr(3, 2);
        tmp += '-';
        tmp += str.substr(5);
        return tmp;
    }

    return str;
}

function reservationNumberSetting(str) {
    str = str.replace(/[^0-9]/g, '');
    var tmp = '';
    if (str.length < 11) {
        return str;
    } else if (str.length < 14) {
        tmp += str.substr(0, 10);
        tmp += '-';
        tmp += str.substr(10);
        return tmp;
    } else {
        tmp += str.substr(0, 10);
        tmp += '-';
        tmp += str.substr(10);
        return tmp;
    }

    return str;
}

//날짜 표기형식 세팅
function setDateTime(item,type,unit){
	let setDate = "";
	if(item){
		let basicDate = String(item).indexOf("-") > 0 || String(item).indexOf(".") > 0 ? String(item).replace(/-\./g,"/") : item;
		let date = new Date(basicDate),
			yy,
			yyMin,
			mm,
			dd,
			th,
			tm,
			ts;

		yy = date.getFullYear();
		yyMin = String(date.getFullYear()).substr(2,2);
		mm = date.getMonth() + 1 <= 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
		dd = date.getDate() <= 9 ? "0" + date.getDate() : date.getDate();
		th = date.getHours() <= 9 ? "0" + date.getHours() : date.getHours();
		tm = date.getMinutes() <= 9 ? "0" + date.getMinutes() : date.getMinutes();
		ts = date.getSeconds() <= 9 ? "0" + date.getSeconds() : date.getSeconds();
		
		if(type == "yymmdd"){
			if(unit == "ymd"){
				setDate = yy + "년 " + mm + "월 " + dd + "일";
			}else if(unit == "hymd"){
				setDate = yy + "-" + mm + "-" + dd;
			}else if(unit == "not"){
				setDate = `${yy}${mm}${dd}`;
			}else{
				setDate = yy + "." + mm + "." + dd;
			}
		}else if(type == "yymmddhhtt"){
			if(unit == "ymd"){
				setDate = yy + "년 " + mm + "월 " + dd + "일 " + th + ":" + tm;
			}else if(unit == "hymd"){
				setDate = yy + "-" + mm + "-" + dd + " " + th + ":" + tm;
			}else{
				setDate = yy + "." + mm + "." + dd + " " + th + ":" + tm;
			}
		}else if(type == "mmdd"){
			if(unit == "ymd"){
				setDate = mm + "월 " + dd + "일";
			}else if(unit == "hymd"){
				setDate = mm + "-" + dd;
			}else if(unit == "slash"){
				setDate = mm + "/" + dd;
			}else{
				setDate = mm + "." + dd;
			}
		}else if(type == "yymm"){
			if(unit == "ymd"){
				setDate = yy + "년 " + mm + "월";
			}else if(unit == "hymd"){
				setDate = yy + "-" + mm;
			}else if(unit == "slash"){
				setDate = yy + "/" + mm;
			}else{
				setDate = yy + "." + mm;
			}
		}else if(type == "day"){
			setDate = dd;
		}else if(type == "yymmddhhttss"){
			if(unit == "ymd"){
				setDate = yy + "년 " + mm + "월 " + dd + "일 " + th + ":" + tm + ":" + ts;
			}else if(unit == "hymd"){
				setDate = yy + "-" + mm + "-" + dd + " " + th + ":" + tm + ":" + ts;
			}else{
				setDate = yy + "." + mm + "." + dd + " " + th + ":" + tm + ":" + ts;
			}
		}else if(type == "hhttss"){
			setDate = th + ":" + tm + ":" + ts;
		}else if(type == "hhtt"){
			setDate = th + ":" + tm;
		}else if(type == "dayyymmddhhss"){
			if(unit == "ymd"){
				setDate = yy + "년 " + mm + "월 " + dd + "일(" + setDateWeek(item) + ") " + th + ":" + tm + ":" + ts;
			}else if(unit == "hymd"){
				setDate = yy + "-" + mm + "-" + dd + "(" + setDateWeek(item) + ") " + th + ":" + tm + ":" + ts;
			}else if(unit == "ymdhi"){
                setDate = yy + "." + mm + "." + dd + "(" + setDateWeek(item) + ") " + th + ":" + tm;
            }else{
				setDate = yy + "." + mm + "." + dd + "(" + setDateWeek(item) + ") " + th + ":" + tm + ":" + ts;
			}
		}else if(type == "dayyymmddhh"){
			if(unit == "ymd"){
				setDate = yy + "년 " + mm + "월 " + dd + "일(" + setDateWeek(item) + ") " + th + ":" + tm;
			}else if(unit == "hymd"){
				setDate = yy + "-" + mm + "-" + dd + "(" + setDateWeek(item) + ") " + th + ":" + tm;
			}else{
				setDate = yy + "." + mm + "." + dd + "(" + setDateWeek(item) + ") " + th + ":" + tm;
			}
		}else if(type == "dayyyMinmmddhh"){
			if(unit == "ymd"){
				setDate = yyMin + "년 " + mm + "월 " + dd + "일(" + setDateWeek(item) + ") " + th + ":" + tm;
			}else if(unit == "hymd"){
				setDate = yyMin + "-" + mm + "-" + dd + "(" + setDateWeek(item) + ") " + th + ":" + tm;
			}else{
				setDate = yyMin + "." + mm + "." + dd + "(" + setDateWeek(item) + ") " + th + ":" + tm;
			}
		}else if(type == "daymmddhh"){
			if(unit == "ymd"){
				setDate = mm + "월 " + dd + "일(" + setDateWeek(item) + ") " + th + ":" + tm;
			}else if(unit == "hymd"){
				setDate = mm + "-" + dd + "(" + setDateWeek(item) + ") " + th + ":" + tm;
			}else{
				setDate = mm + "." + dd + "(" + setDateWeek(item) + ") " + th + ":" + tm;
			}
		}else{
			setDate = yy + "." + mm + "." + dd + " " + th + ":" + tm + ":" + ts;
		}
	}
	return setDate;
}

//날짜 요일 세팅
function setDateWeek(item){
    const weekArr = ["일","월","화","수","목","금","토"];
	if(item){
		let basicDate = String(item).indexOf("-") > 0 || String(item).indexOf(".") > 0 ? String(item).replace(/-\./g,"/") : item;
		let date = new Date(basicDate)
		let setWeek = weekArr[date.getDay()];

		return setWeek;
	}else{
		return "";
	}
}

//날짜 차이
function getDateGap(start,end,type,todayChk){
	if(start){
		let startDate = new Date(start.replace(/\.-/g,"/")),
			endDate = new Date(end.replace(/\.-/g,"/"));

		let dateGap = endDate.getTime() - startDate.getTime();
		let timeGap = new Date(0, 0, 0, 0, 0, 0, endDate - startDate);

		let setDay = Math.floor(dateGap / (1000 * 60 * 60 * 24));   
		let setH = timeGap.getHours();
		let setM  = timeGap.getMinutes();

		let setTime = Math.floor(dateGap / (1000 * 60 * 60));   

		let setting = type == "day" ? setDay + (todayChk ? 0 : 1) : `${setDay + (todayChk ? 0 : 1)}일 ${setH}시간 ${setM}분`;
		
		return type == "time" ? setTime : setting;
	}else{
		return 0;
	}
}

//나이 계산
function ageSetting(birth){
	let today = new Date();
	let birthDate = birth ? birth.length > 4 ? new Date(birth.replace(/\.-/g,"/")) : new Date(birth, 1, 1) : "";
	let age = birth ? today.getFullYear() - birthDate.getFullYear() + 1 : null;

	return age;
}

function americanAgeSetting(birth) {
	let birthData = new Date(birth.replace(/\.-/g,"/"));
	let birthYY = birthData.getFullYear();
	let birthMM = birthData.getMonth();
	let birthDD = birthData.getDate();
  
	let today = new Date();
	let todayYY = today.getFullYear();
	let todayMM = today.getMonth();
	let todayDD = today.getDate();
  
	let age = todayYY - birthYY;
  
	if(todayMM < birthMM){
		age--;
	}else if(todayMM === birthMM && todayDD < birthDD){
		age--;
	}
  
	return age;
}

//url 파라미터
function getParam(sname) {
	var params = window.location.search.substr(window.location.search.indexOf("?") + 1);
	var sval = "";
	params = params.split("&");
	for (var i = 0; i < params.length; i++) {
		let temp = params[i].split("=");
		if ([temp[0]] == sname) {
			sval = temp[1];
		}
	}
	return sval;
}

function getParamText(sname,url) {
	var urlSet = new URL(url);
	var params = urlSet.search.substr(urlSet.search.indexOf("?") + 1);
	var sval = "";
	params = params.split("&");
	for (var i = 0; i < params.length; i++) {
		let temp = params[i].split("=");
		if ([temp[0]] == sname) {
			sval = temp[1];
		}
	}
	return sval;
}

//url 파라미터 소셜 로그인용
function getParam_sns(sname) {
	var params = window.location.search.substr(window.location.search.indexOf("?") + 1);
	var sval = "";
	params = window.location.href.split("#")[1].split("&");
	for (var i = 0; i < params.length; i++) {
		let temp = params[i].split("=");
		if ([temp[0]] == sname) {
			sval = temp[1];
		}
	}
	return sval;
}

//스크롤 하단 체크
function bottomChk(){
    let scrollTop = document.documentElement.scrollTop,
		innerHeight = window.innerHeight,
		scrollHeight = document.querySelectorAll("body")[0].scrollHeight;

    if (Math.ceil(scrollTop + innerHeight) + 1 >= scrollHeight) {
        return true;
    } else {
        return false;
    }
}

//요소 스크롤 하단 체크
function bottomChkEl(el){
    let scrollTop = el.scrollTop,
		innerHeight = el.clientHeight,
		scrollHeight = el.scrollHeight;

    if (Math.ceil(scrollTop + innerHeight) + 1 >= scrollHeight) {
        return true;
    } else {
        return false;
    }
}

//토글 슬라이드
function slideUp(target, duration){
	target.style.transitionProperty = "height, margin, padding";
	target.style.transitionDuration = duration + "ms";
	target.style.boxSizing = "border-box";
	target.style.height = target.offsetHeight + "px";
	target.style.overflow = "hidden";
	window.setTimeout(() => {
		target.style.height = 0;
		target.style.paddingTop = 0;
		target.style.paddingBottom = 0;
		target.style.marginTop = 0;
		target.style.marginBottom = 0;
	}, 10);
	window.setTimeout(() => {
		target.style.display = "none";
		target.style.removeProperty("height");
		target.style.removeProperty("padding-top");
		target.style.removeProperty("padding-bottom");
		target.style.removeProperty("margin-top");
		target.style.removeProperty("margin-bottom");
		target.style.removeProperty("overflow");
		target.style.removeProperty("transition-duration");
		target.style.removeProperty("transition-property");
	}, duration);
}
function slideDown(target, duration, type){
	target.style.removeProperty("display");
	let display = window.getComputedStyle(target).display;

	if (display === "none") display = type == "flex" ? "flex" : "block";

	target.style.display = display;
	let height = target.offsetHeight;
	target.style.overflow = "hidden";
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	target.style.height = target.offsetHeight + "px";
	target.style.boxSizing = "border-box";
	target.style.transitionProperty = "height, margin, padding";
	target.style.transitionDuration = duration + "ms";
	target.style.height = height + "px";
	target.style.removeProperty("padding-top");
	target.style.removeProperty("padding-bottom");
	target.style.removeProperty("margin-top");
	target.style.removeProperty("margin-bottom");
	window.setTimeout(() => {
		target.style.removeProperty("height");
		target.style.removeProperty("overflow");
		target.style.removeProperty("transition-duration");
		target.style.removeProperty("transition-property");
	}, duration);
}
function slideToggle(target, type){
  if (window.getComputedStyle(target).display === "none") {
    return slideDown(target, 300, type);
  } else {
    return slideUp(target, 300);
  }
}

//스크롤 이동
function moveScroll(item,addTop){
	let scrollItem = document.querySelectorAll(item)[0].offsetTop;
	window.scrollTo({left: 0, top: addTop ? scrollItem - addTop : scrollItem, behavior: "smooth"});
}

//스크롤 제한(팝업용)
function bodyScroll_limit(){
	document.querySelectorAll("body")[0].classList.add("active");
}
function bodyScroll_clear(){
	document.querySelectorAll("body")[0].classList.remove("active");
}

//천단위 콤마 포멧
function comFormat(number){
	let data = Number(number);

	if (data == 0) return 0;
	var reg = /(^[+-]?\d+)(\d{3})/;
	var n = (data + '');
	while (reg.test(n)) n = n.replace(reg, '$1' + ',' + '$2');
	return n;
}

//dday 체크
function dDay(data){
	const now = new Date();
	const use_date = new Date(data.replace(/-/g,"/"));

	const setDate = use_date - now;

	const day = Math.floor(setDate / (1000 * 60 * 60 * 24));

	return day;
}

//평일,주말 체크
function getWeekCount(start,end) {
    let startDate = new Date(start.replace(/-/g,"/")),
     	endDate = new Date(end.replace(/-/g,"/"));

    let weekdayCount = 0,
		weekendCount = 0;

	while(true) {
		let setStartDate = startDate;				
		if(setStartDate.getTime() > endDate.getTime()) {
			return [weekdayCount,weekendCount];
		} else {
			let tmp = setStartDate.getDay();
			if(tmp == 0 || tmp == 6) {//주말에 금요일 제외 필요하면 tmp == 5 추가
				weekendCount++;
			} else {
				weekdayCount++;         
			}
			setStartDate.setDate(startDate.getDate() + 1); 
		}
	}
}

//스타일 추출
function getStyle(el, prop, type){
	let style;
    if(el?.currentStyle){
        style = el?.currentStyle[prop];
    }else if(window?.getComputedStyle && el){
        style = type == "number" ? window?.getComputedStyle(el,null)[prop].replace(/[a-zA-Z#?!@$ %^&*-]/gi,"") : window?.getComputedStyle(el,null)[prop];
    }
    return style;
}

function basicImgSet(img){
	if(img){
		return img;
	}else{
		return "/assets/images/img/basic.svg";
	}
}

function timeArr(timeStart,timeEnd,timeUnit){
	let timeSet = Number(timeStart);
	let timeArr = [];

	do {
		let h = String(timeSet).substring(0,String(timeSet).length <= 3 ? 1 : 2),
			m = String(timeSet).substring(String(timeSet).length <= 3 ? 1 : 2,String(timeSet).length <= 3 ? 3 : 4);
		
		if(m >= 60){
			m = m - 60;
			h = Number(h) + 1;
		}

		if(Number(m) < 10){
			m = `0${Number(m)}`;
		}

		if(Number(h) < 10){
			h = `0${Number(h)}`;
		}

		timeArr.push(`${h}:${m}`);
		timeSet = Number(`${h}${m}`) + timeUnit;
	} while (timeSet <= Number(timeEnd));

	return timeArr;
}

//주차 추출
function weekArr(dateType){
	let nowDate = new Date(),
        nowY = nowDate.getFullYear(),
        nowM = nowDate.getMonth(),
        nowD  = nowDate.getDate(),
        nowDay = nowDate.getDay();
    
    let week = [];
        
    for(var i = 1 + dateType * 7; i < 8 + dateType * 7; i++) {
        let resultDate = new Date(nowY, nowM, nowD + (i - nowDay)),
            yy = resultDate.getFullYear(),
            mm = Number(resultDate.getMonth()) + 1,
            dd = resultDate.getDate();
        
        mm = mm < 10 ? "0" + mm : mm;
        dd = dd < 10 ? "0" + dd : dd;
        
        week.push({
            y: String(yy),
            m: String(mm),
            d: String(dd),
			weekDay: setDateWeek(`${yy}/${mm}/${dd}`),
			fullDate: `${yy}-${mm}-${dd}`
        });
    }

	return week;
}

function ageSet(date,yy){
	const today = new Date(date?.replace(/-/g,"/"));
	const birthDate = new Date(`${yy}/1/1`);

	let age = today.getFullYear() - birthDate.getFullYear() + 1;

	return age;
}

function carCode(type,code){
	let text = "";
	
	if(type === "fuelType"){//연료 구분 코드
		if(code == "0001"){text = "경유"}
		if(code == "0002"){text = "휘발유"}
		if(code == "0003"){text = "LPG"}
		if(code == "0004"){text = "전기"}
		if(code == "0005"){text = "하이브리드"}
	}

	if(type === "carCategory"){//차량 분류 코드
		if(code == "0001"){text = "경차"}
		if(code == "0002"){text = "소형"}
		if(code == "0003"){text = "준중형"}
		if(code == "0004"){text = "중형"}
		if(code == "0005"){text = "대형"}
		if(code == "0006"){text = "RV/SUV"}
		if(code == "0007"){text = "승합"}
		if(code == "9999"){text = "기타"}
	}

	if(type === "InsuranceType"){//보험 구분 코드
		if(code == "2000"){text = "일반 자차"}
		if(code == "3000"){text = "고급/완전 자차"}
		if(code == "5000"){text = "부분 무제한 자차"}
		if(code == "6000"){text = "슈퍼 무제한 자차"}
		if(code == "9000"){text = "기타"}
	}

	if(type === "InsuranceChargeType"){//보험 요금 산정 구분 코드
		if(code == "1001"){text = "일단위"}
		if(code == "1002"){text = "일단위(직접)"}
		if(code == "1003"){text = "일단위(패턴)"}
		if(code == "2001"){text = "24 시간단위"}
		if(code == "2002"){text = "시간단위(1,6,12,24 시간)"}
	}

	if(type === "carOptionType"){//차량 옵션 분류 코드
		if(code == "RESTRICTION"){text = "탑승제한"}
		if(code == "CAMERA"){text = "카메라 옵션"}
		if(code == "SENSOR"){text = "센서 옵션"}
		if(code == "AUDIO"){text = "오디오 옵션"}
		if(code == "SEAT"){text = "시트 옵션"}
		if(code == "CONVENIENCE"){text = "편의 옵션"}
		if(code == "SAFETY"){text = "안전 옵션"}
		if(code == "KEY"){text = "키 옵션"}
	}

	if(type === "CarOptionCode"){//차량 옵션 상세 코드
		if(code == "RESTRICTION001"){text = "금연"}
		if(code == "RESTRICTION002"){text = "반려동물 동반가능"}
		if(code == "RESTRICTION003"){text = "외국인대여 가능"}
		if(code == "CAMERA001"){text = "네비(거치형)"}
		if(code == "CAMERA002"){text = "네비(매립형)"}
		if(code == "CAMERA003"){text = "카플레이"}
		if(code == "CAMERA004"){text = "후방카메라"}
		if(code == "CAMERA005"){text = "후방주시 카메라"}
		if(code == "CAMERA006"){text = "서라운드 뷰"}
		if(code == "CAMERA007"){text = "HUD"}
		if(code == "CAMERA008"){text = "네비(매립+거치 랜덤)"}
		if(code == "SENSOR001"){text = "후방센서"}
		if(code == "SENSOR002"){text = "전방센서"}
		if(code == "SENSOR003"){text = "후측방센서"}
		if(code == "AUDIO001"){text = "AUX"}
		if(code == "AUDIO002"){text = "USB"}
		if(code == "AUDIO003"){text = "블루투스"}
		if(code == "AUDIO004"){text = "C 형단자"}
		if(code == "AUDIO005"){text = "시거잭"}
	}

	if(type === "reservation"){
		if(code == "0"){text = "이용 예정"}
		if(code == "1"){text = "이용 중"}
		if(code == "2"){text = "이용 완료"}
		if(code == "10"){text = "예약 취소"}
	}

	if(type === "reservationLabelColor"){
		if(code == "0"){text = "yColor"}
		if(code == "1"){text = "bColor"}
		if(code == "2"){text = "gColor"}
		if(code == "10"){text = "rColor"}
	}

	if(type === "payment_method"){
		if(code == "billing"){
			text = "카드결제"
		}else if(code == "card"){
			text = "카드결제"
		}else if(code == "phone"){
			text = "휴대폰"
		}else if(code == "naver"){
			text = "네이버"
		}else if(code == "kakao"){
			text = "카카오"
		}else{
			text = code
		}
	}
	   
	return text;
}

function paymentFailedCode(code){
	let text = code;

	if(code == "NOT_VALID_FEE"){text = "이용 금액이 올바르지 않습니다."}
	if(code == "NOT_CORRECT_INSURANCE"){text = "보험 정보가 올바르지 않습니다."}
	if(code == "OVER_RESERVATION_MAX_DAY"){text = "최대 예약 기간을 초과하였습니다."}
	if(code == "OVER_RESERVATION_TIME"){text = "예약이 가능한 기간이 아닙니다."}
	if(code == "NO_AVAILABLE_CAR"){text = "이용 가능한 차량이 없습니다."}
	if(code == "DUPLICATED_RESERVATION_ID"){text = "동일한 거래처 예약번호가 존재합니다."}
	if(code == "INTERNAL_UNKNOWN_ERROR"){text = "서버에서 알 수 없는 오류가 발생했습니다."}
	   
	return text;
}

function arrParam(arr,key,firstChk,valKey){
	let param = "";

	if(arr){
		arr?.forEach(function(item,i){
			if(i == 0 && firstChk){
				param = param + `?${key}=${valKey ? item[valKey] : item}`;
			}else{
				param = param + `&${key}=${valKey ? item[valKey] : item}`;
			}
		})
	}

	return param;
}

function datePramaSet(data){
	let textSet = /[\s\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi;
	let text = data.replace(textSet,"");
	if(text.length >= 14){
		text = text?.slice(0,12);
	}

	return text;
}

function isMobile(){
	const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

	return regex.test(navigator.userAgent);
}

function feePercent(start_date,payment_date,priceData){
	let percent = 0;
	let newDate = new Date();
	let now = setDateTime(newDate,"yymmddhhtt","hymd");
	let gapTime = start_date ? getDateGap(now,start_date,"time",null) : null

	if(payment_date && getDateGap(payment_date,now,"time",null) <= 0){
		percent = priceData?.one_hour_before||0;
	}else if(gapTime && gapTime > 72){
		percent = priceData?.three_day_before||0;
	}else if(start_date && getDateGap(setDateTime(now,"yymmdd","hymd"),setDateTime(start_date,"yymmdd","hymd"),"day",true) <= 0){
		percent = priceData?.day_cancel||0;
	}else if(gapTime && gapTime <= 24){
		percent = priceData?.one_day||0;
	}else if(gapTime && gapTime <= 48){
		percent = priceData?.two_day||0;
	}else if(gapTime && gapTime <= 72){
		percent = priceData?.three_day||0;
	}else{
		percent = 100;
	}

	return percent;
}

function feeText(priceData){
	let text = null;

	if(!priceData?.one_hour_before){
		text = "예약(결제) 시점 1시간 이내"
	}else if(!priceData?.three_day_before){
		text = "대여 시간 72시간 이전"
	}else if(!priceData?.three_day){
		text = "대여 시간 72시간 이내"
	}else if(!priceData?.two_day){
		text = "대여 시간 48시간 이내"
	}else if(!priceData?.one_day){
		text = "대여 시간 24시간 이내"
	}

	return text;
}

function birthdaySet(birthday,gender){
	let text = "";

	if(birthday && gender){
		let yType = birthday?.substr(0,2);

		if(Number(yType) <= 19){
			if(gender == "m"){
				text = birthday?.substr(2,8) + "1";
			}else{
				text = birthday?.substr(2,8) + "2";
			}
		}else{
			if(gender == "m"){
				text = birthday?.substr(2,8) + "3";
			}else{
				text = birthday?.substr(2,8) + "4";
			}
		}
	}

	return text;
}

//앱구분
function appType(){
	const varUA = navigator.userAgent;
	let type = null;

	if(varUA.match("arentacarhub/Android") != null) {
		type = "Android";
	}else if(varUA.match("arentacarhub/iOS") != null) {
		type = "iOS";
	}else{
		type = null;
	}

	return type;
}

//앱 토큰 저장
function tokenSave(token){
	if(appType() === "Android"){
		window.arentacarhub.autoLogin(token);
	}else if(appType() === "iOS"){
		window.webkit.messageHandlers.autoLoginHandler.postMessage(token);
	}
}


export {PhoneSetting, birthSetting, CardNumberSetting, BusinessNumberSetting, reservationNumberSetting, cardDateSetting, cardBirthSetting, bottomChk, bottomChkEl, slideUp, slideDown, slideToggle, ageSetting, americanAgeSetting, getParam, getParamText, getParam_sns, comFormat, dDay, setDateTime, moveScroll, getDateGap, setDateWeek, getStyle, getWeekCount, bodyScroll_limit, bodyScroll_clear, basicImgSet,timeArr,weekArr,ageSet,carCode,arrParam,datePramaSet,paymentFailedCode,isMobile,feePercent,feeText,appType,tokenSave,birthdaySet};